// MembershipAddWizard.jsx
import React, { useState, useContext } from 'react'
import { store } from '../../../../../../../../context/StateProvider';
import MembershipWizard from '../membership-form/MembershipWizard';
import APIResponse from '../../../../../../../templates/components/APIResponse';
import ProductService from '../../../../../../../../services/api/product.service';
import moment from 'moment';

const MembershipAddWizard = ({ embed, refresh, exitHandler, onClose }) => {
  const [apiResponse, setApiResponse] = useState();

  const stateAndDispatch = useContext(store)
  const state = stateAndDispatch.state
  const [locationId, setLocationId] = useState(state.practiceLocationId);


  const onSuccess = () => {
    refresh?.();
    onClose?.();
    exitHandler?.();
  };

  const submitHandler = (data, items) => {
    let reqObj = { ...data };
    reqObj.itemType = 5;
    reqObj.membershipInstructions = reqObj.membershipInstructions || "";
    reqObj.membershipItems = items.filter(x => x.itemId !== null).map(x => {
      if (x.priceOverride && (x.unitPrice === "" || x.unitPrice == null)) x.unitPrice = 0;
      else if (!x.priceOverride) x.unitPrice = null;

      if (x.discountOverride && (x.discount === "" || x.discount == null)) x.discount = 0;
      else if (!x.discountOverride) x.discount = null;

      return x;
    });
    reqObj.membershipOfferBeginsOn = moment(reqObj.membershipOfferBeginsOn).startOf('day').toISOString();
    reqObj.membershipOfferEndsOn = reqObj.membershipOfferEndsOn
      ? moment(reqObj.membershipOfferEndsOn).startOf('day').toISOString()
      : null;

    reqObj.membershipPeriodQty = isNaN(reqObj?.membershipPeriodQty) ? 0 : Number(reqObj.membershipPeriodQty);
    reqObj.unitPrice = isNaN(reqObj?.unitPrice) ? 0 : Number(reqObj.unitPrice);

    if (reqObj.membershipItemsNeverExpire) {
      reqObj.membershipItemsNeverExpire = 1;
    } else {
      delete reqObj.membershipItemsNeverExpire;
    }

    ProductService.addProduct(reqObj)
      .then(setApiResponse)
      .catch(setApiResponse);
  };

  return (
    <>
      <MembershipWizard
        isEdit={false}
        initialData={{practiceLocationId: locationId}}
        onSubmit={submitHandler}
        onClose={onClose}
      />
      <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true} />
    </>
  );
};

export default MembershipAddWizard;
